import fetchWithAuthorization from './fetch-with-authorization'
import { END_POINTS } from './end-points'

export const getTransactions = async (from = '', to = '', after = '') => {
  return await fetchWithAuthorization({
    path: END_POINTS.TRANSACTIONS.BASE + `?from=${from}&to=${to}&after=${after}`,
  })
}

export const getPendingTransactions = async () => {
  return await fetchWithAuthorization({
    path: END_POINTS.TRANSACTIONS.PENDING_TRANSACTIONS,
  })
}

export const getCurrentMonthSpending = async () => {
  return await fetchWithAuthorization({
    path: END_POINTS.TRANSACTIONS.CURRENT_MONTH_SPENDING,
  })
}
